module.exports = __webpack_public_path__ + "static/ResHouses-613ceaeab8155211df1e61ffd979f2e4.png";